import { render, staticRenderFns } from "./selectedChild.vue?vue&type=template&id=a02ae884&scoped=true"
import script from "./selectedChild.vue?vue&type=script&lang=js"
export * from "./selectedChild.vue?vue&type=script&lang=js"
import style0 from "./selectedChild.vue?vue&type=style&index=0&id=a02ae884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02ae884",
  null
  
)

export default component.exports